import { Report, ReportStatus } from 'src/types/Report';

export const hasPendingReports = (reports: Report[]): boolean =>
  reports.some(
    (report) => report.status === ReportStatus.EXPORT_STATUS_PENDING
  );
